import script from "./add-register.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-register.vue?vue&type=script&setup=true&lang=ts"

import "./add-register.vue?vue&type=style&index=0&id=42edff86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42edff86"]])

export default __exports__